import React, { useEffect } from 'react';
import { useAuthorizationStatus } from '@mos-utils/acs-react';
import acs from '@mos-utils/acs';
import Modal from '@mos-cat/modal';

import Button from '../components/Button/Button';
import Content from '../components/Content/Content';
import Spinner from '../components/Spinner/Spinner';
import FormPage from '../containers/FormPage';

import { sendCMAAppealBusinessError } from '../helpers/CMAStats';

function getBackUrl() {
  if (window.location.href.includes('new')) {
    return window.location.href;
  }
  return window.location.href + 'new/';
}

const FormPageLayout = () => {
  const authorizationStatus = useAuthorizationStatus();

  useEffect(() => {
    if (authorizationStatus === 'unauthorized') {
      const url = getBackUrl();
      acs.login(url);
    }

    if (authorizationStatus === 'unauthorized') {
      sendCMAAppealBusinessError({ stage: 'start' });
    }
  }, [authorizationStatus]);

  if (authorizationStatus === 'authorized' || authorizationStatus === 'exit') {
    return <FormPage />;
  }

  if (authorizationStatus === 'unknown') {
    return (
      <div className="FormPage">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="FormPage">
      <Modal visible onCancel={() => {}}>
        <div className="ModalError" />
        <Content>
          <Content.Title>Произошла ошибка авторизации</Content.Title>
          <Content.Text>
            Попробуйте заново войти в личный кабинет и продолжить
          </Content.Text>
          <Content.Button>
            <Button
              primary
              onClick={() => {
                acs.login(window.location.href);
              }}
            >
              Войти
            </Button>
          </Content.Button>
        </Content>
      </Modal>
    </div>
  );
};

export default FormPageLayout;
